/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBackupMemberUpdateMutationVariables = Types.Exact<{
  input: Types.IBackupMemberUpdateInput;
}>;

export type IBackupMemberUpdateMutation = {
  __typename?: 'Mutation';
  backupMemberUpdate?: {
    __typename?: 'BackupMemberUpdatePayload';
    errors?: Array<string> | null;
    success: boolean;
    backupMember?: {
      __typename?: 'BackupMember';
      id: string;
      role: Types.BackupMemberRoleEnum;
      user: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        email: string;
        phone?: string | null;
        role: Types.UserRoleEnum;
      };
      policy: { __typename?: 'BackupMemberPolicy'; remove: boolean; update: boolean };
    } | null;
  } | null;
};

export const BackupMemberUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'backupMemberUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BackupMemberUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backupMemberUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backupMember' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BackupMemberFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BackupMemberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BackupMember' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBackupMemberUpdateMutation, IBackupMemberUpdateMutationVariables>;
